import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { enumData, loading, userPrefPageSize } from '@/decorators';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import userLimit from '@/decorators/modules/userLimit';
import { namespace } from 'vuex-class';
var User = namespace('user');

var ClearanceListPage = function (_super) {
  __extends(ClearanceListPage, _super);

  function ClearanceListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.clearanceConfirmStatusEnum = [];
    _this.total = 0;
    _this.docValue = '';
    _this.columns = [];
    _this.selectedList = [];
    _this.editData = {};
    _this.rowSelection = {};
    _this.searchData = _this.initSearchData();
    _this.searchParam = _this.initSearchData();
    _this.data = [];
    _this.shippingMethodList = [];
    _this.transitionWarehouseList = [];
    _this.warehouseList = [];
    _this.loadingStatus = false;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.statusCountList = [];
    _this.codeTypeEnum = [];
    _this.transitLogisticsProductCodeEnum = [];
    _this.timeTypeEnum = [];
    return _this;
  }

  Object.defineProperty(ClearanceListPage.prototype, "statusList", {
    get: function get() {
      return this.$util.mergeCountDataToStatusEnum(this.clearanceConfirmStatusEnum || [], this.statusCountList || []);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ClearanceListPage.prototype, "idList", {
    get: function get() {
      var _this = this;

      return this.data.filter(function (item) {
        return _this.selectedList.includes(item.order_no);
      }).map(function (item) {
        return item.id;
      });
    },
    enumerable: false,
    configurable: true
  });

  ClearanceListPage.prototype.updateSearchList = function () {
    this.getList();
  };

  ClearanceListPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.time_start = '';
      this.searchData.time_end = '';
    }
  };

  ClearanceListPage.prototype.initSearchData = function () {
    return {
      code_type: this.$enum.clearance.ClearanceConfirmCodeTypeEnum.ORDER_CODE,
      code_value: [],
      time_type: this.$enum.clearance.ClearanceConfirmTimeTypeEnum.CREATE_TIME,
      time_start: undefined,
      time_end: undefined,
      product_code: undefined,
      transit_warehouse_code: undefined,
      warehouse_code: undefined,
      status: this.$enum.clearance.ClearanceStatusEnum.ALL,
      page_index: 1,
      page_size: 20
    };
  };

  ClearanceListPage.prototype.addDefaultSearchData = function () {
    if (!this.$route.query.from) {
      return;
    }

    var status = this.$route.query.status;
    var datetimeDefaultValue = this.$route.query.datetimeDefaultValue;

    if (status) {
      this.searchData.status = Number(status);
    }

    if (status) {
      this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(this.$util.monthToDay());
    }

    if (datetimeDefaultValue) {
      this.datetimeDefaultValue = JSON.parse(datetimeDefaultValue);
    }
  };

  ClearanceListPage.prototype.getList = function () {
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    this.queryList(this.searchData);
  };

  ClearanceListPage.prototype.queryList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchParam = this.$util.deepCopy(params);
            this.total = null;

            if (this.searchParam.status === this.$enum.clearance.ClearanceStatusEnum.ALL) {
              delete this.searchParam.status;
            }

            return [4, this.$api.clearance.queryList(this.searchParam)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.searchData.next_token = res.data.next_token;
              this.searchData.prev_token = res.data.prev_token;
              this.data = res.data.confirm_data_list || [];
              this.total = res.data.total;
              this.statusCountList = res.data.status_count_list || [];
            }

            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            res = _a.sent();
            this.warehouseList = res.data || [];
            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.queryTransitionWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.queryTransitionWarehouseList()];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.transitionWarehouseList = res.data.list;
            }

            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.exportData = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.clearance["export"](params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$util.exportExcel(res.data);
            }

            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.handleConfirmBulk = function () {
    var _this = this;

    if (!this.selectedList.length) {
      this.$message.warn(this.t('common', '请选择确认项'));
    } else {
      this.$confirm({
        title: this.tc('确认'),
        content: this.t('是否确认该清关文件？'),
        onOk: function onOk() {
          _this.confirmBulk({
            id_list: _this.idList
          });
        }
      });
    }
  };

  ClearanceListPage.prototype.handleConfirm = function (record) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('是否确认该清关文件？'),
      onOk: function onOk() {
        _this.confirmBulk({
          id_list: [record.id]
        });
      }
    });
  };

  ClearanceListPage.prototype.confirmBulk = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.clearance.confirm(params)];

          case 1:
            res = _a.sent();
            this.$message.success(this.t('确认成功'));
            this.getList();
            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.handleChangeStatus = function () {
    this.searchData.page_index = 1;
    this.getList();
  };

  ClearanceListPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      var value;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            value = this.docValue ? this.docValue.split(',') : [];
            this.searchData.page_index = 1;
            this.searchData.code_value = value;
            return [4, this.getList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ClearanceListPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.docValue = '';
        this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
        this.searchData = this.initSearchData();
        this.$nextTick(function () {
          _this.getList();
        });
        return [2];
      });
    });
  };

  ClearanceListPage.prototype.handleDblClick = function () {
    var bulkSearchRef = this.$refs.bulkSearchModal;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  };

  ClearanceListPage.prototype.handlePageChange = function (page, pageSize) {
    if (page > this.searchData.page_index) {
      this.searchData.page_token = this.searchData.next_token;
    } else if (page < this.searchData.page_index) {
      this.searchData.page_token = this.searchData.prev_token;
    } else {
      delete this.searchData.page_token;
    }

    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.getList();
  };

  ClearanceListPage.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.docValue = bulkKeywords;
  };

  ClearanceListPage.prototype.handleExportAll = function () {
    var searchData = this.$util.deepCopy(this.searchData);

    if (searchData.status === this.$enum.clearance.ClearanceStatusEnum.ALL) {
      searchData.status = undefined;
    }

    this.exportData(searchData);
  };

  ClearanceListPage.prototype.handleExportSelected = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }

    var params = {
      code_type: this.$enum.clearance.ClearanceConfirmCodeTypeEnum.ORDER_CODE,
      code_value: this.selectedList
    };
    this.exportData(params);
  };

  ClearanceListPage.prototype.handleSuccessReload = function () {
    this.getList();
  };

  ClearanceListPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('入库单号'),
      name: 'order_no',
      disabled: true,
      dataIndex: 'order_no',
      scopedSlots: {
        customRender: 'order_no'
      },
      filterEmpty: true
    }, {
      title: this.t('状态'),
      name: 'status',
      dataIndex: 'status_text',
      width: 130,
      filterEmpty: true
    }, {
      title: this.t('中转仓'),
      name: 'transit_warehouse_code',
      dataIndex: 'transit_warehouse_code',
      filterEmpty: true,
      width: 120,
      checked: true,
      scopedSlots: {
        customRender: 'transit_warehouse_code'
      }
    }, {
      title: this.t('目的仓（区域）'),
      name: 'warehouse_code',
      width: 200,
      dataIndex: 'warehouse_code',
      scopedSlots: {
        customRender: 'warehouse_code'
      },
      filterEmpty: true
    }, {
      title: this.t('入库单类型'),
      name: 'order_type_text',
      dataIndex: 'order_type_text',
      filterEmpty: true
    }, {
      title: this.t('运输方式'),
      name: 'order_product_code_text',
      dataIndex: 'order_product_code_text',
      filterEmpty: true
    }, {
      title: this.t('跟踪号/海柜号'),
      name: 'sa_tank_no',
      dataIndex: 'sa_tank_no',
      isCopy: true,
      checked: true,
      disabled: true,
      filterEmpty: true
    }, {
      title: this.t('出口报关方式'),
      name: 'customs_type_text',
      dataIndex: 'customs_type_text',
      filterEmpty: true
    }, {
      title: this.t('报关总数量'),
      dataIndex: 'forecast_sku_num',
      align: 'right',
      filterEmpty: true
    }, {
      title: this.t('中转仓实收总数量'),
      align: 'right',
      name: 'actul_sku_num',
      dataIndex: 'actul_sku_num',
      filterEmpty: true
    }, {
      title: this.t('时间'),
      name: 'time',
      dataIndex: 'time',
      scopedSlots: {
        customRender: 'time'
      },
      width: 220
    }, {
      title: this.t('操作'),
      name: 'operation',
      key: 'operation',
      showColumnSetting: true,
      width: 200,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    this.queryTransitionWarehouseList();
    this.queryWarehouseList();
    this.addDefaultSearchData();
    this.$nextTick(function () {
      _this.getList();
    });
  };

  __decorate([enumData('IntlCargo/ClearanceConfirmStatusEnum')], ClearanceListPage.prototype, "clearanceConfirmStatusEnum", void 0);

  __decorate([enumData('IntlCargo/ClearanceConfirmCodeTypeEnum')], ClearanceListPage.prototype, "codeTypeEnum", void 0);

  __decorate([enumData('IntlCargo/TransitLogisticsProductCodeEnum')], ClearanceListPage.prototype, "transitLogisticsProductCodeEnum", void 0);

  __decorate([enumData('IntlCargo/ClearanceConfirmTimeTypeEnum')], ClearanceListPage.prototype, "timeTypeEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], ClearanceListPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('clearanceList')], ClearanceListPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ClearanceListPage.prototype, "queryList", null);

  __decorate([userLimit()], ClearanceListPage.prototype, "handleConfirmBulk", null);

  __decorate([userLimit()], ClearanceListPage.prototype, "handleConfirm", null);

  ClearanceListPage = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal
    }
  })], ClearanceListPage);
  return ClearanceListPage;
}(Vue);

export default ClearanceListPage;